export const findLocationEntry = <T extends {id: string; children: T[]}>(
  locations: T,
  locationId: string
): T | undefined => {
  if (locations.id === locationId) {
    return locations
  }
  for (const child of locations.children) {
    const result = findLocationEntry(child, locationId)
    if (result) {
      return result
    }
  }
}
